<template>
  <div id="bom-hierarchy-view">
    <div class="actions">
      <!-- <ButtonGroup>
        <Button class="history" @click="history_go(true)" :disabled="history_list.length === 0 || (history_list.length > 0 && history_cursor === 0)"><Tooltip transfer :content="$t('bom_tool.edit.history.prev')"><Icon type="md-undo" /></Tooltip></Button>
        <Button class="history" @click="history_go(false)" :disabled="history_list.length === 0 || (history_list.length > 0 && history_cursor === -1)"><Tooltip transfer :content="$t('bom_tool.edit.history.next')"><Icon type="md-redo" /></Tooltip></Button>
      </ButtonGroup> -->
      <Button @click="rowsMoveWidgetConfig.modalMoveRows = true" class="move" disabled>{{ $t('bom_tool.edit.move.move') }}</Button>
      <div class="clear"></div>
    </div>
    <div class="bom-hierarchy-table">
      <vxe-grid
        size="mini"
        height="auto"
        highlight-hover-row
        row-key
        border
        ref="xTable"
        class="sortable-tree-demo"
        row-id="id"
        @edit-closed="finishEdit"
        :cell-class-name="cellClass"
        :row-class-name="rowClassName"
        :columns="tableColumn"
        :data="tableTreeData"
        :expand-config="{
          visibleMethod: ifExpand
        }"
        :checkbox-config="{
          showHeader: true,
          range: true
        }"
        :edit-config="{
          trigger: 'click',
          mode: 'cell',
          icon: ' '
        }"
        :tree-config="{
          children: 'children',
          indent: 12
        }">
        <template v-slot:error="{ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex }">
          <span>{{ row.col_row_index }}</span><Icon v-if="isError(row.col_row_index)" :title="getErrorMessage(row.col_row_index)" type="md-warning" class="row-error-tooltip" />
        </template>
        <template v-slot:expand="{ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex }">
          <vxe-grid
            size="mini"
            border
            class="sortable-tree-demo"
            row-id="id"
            @edit-closed="finishExpandEdit"
            :ref="`xTableExpand${rowIndex}`"
            :cell-class-name="addExpandClass"
            :show-header="false"
            :edit-config="{
              trigger: 'click',
              mode: 'cell'
            }"
            :columns="tableColumnExpand"
            :data="row.alternatives">
          </vxe-grid>
        </template>
      </vxe-grid>
    </div>
    <Spin fix size="large" v-if="loading">
      <slot name="loading"></slot>
    </Spin>
    <!-- <Modal v-model="rowsMoveWidgetConfig.modalMoveRows"
           :title="$t('bom_tool.edit.move.modal_title')"
           :ok-text="$t('bom_tool.edit.move.move')"
           @on-ok="handleRowsMove">
      <div>{{ $t('bom_tool.edit.move.modal_input') }}</div><InputNumber :min="1" :step="1" :precision="0" v-model="rowsMoveWidgetConfig.parentRowIndex" class="target-row"></InputNumber>
      <Table :columns="rowsMoveWidgetConfig.headersForRowsMoveTable" :data="selectedRows" border></Table>
    </Modal> -->
  </div>
</template>

<script>
import Vue from 'vue'
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import Sortable from 'sortablejs'
import VxeGridTableEnhancement from '@/plugin/sortablejs-ext/VxeGridTableEnhancement'
import VXETablePluginIView from 'vxe-table-plugin-iview'
import 'vxe-table-plugin-iview/dist/style.css'

Vue.use(VXETable)
VXETable.use(VXETablePluginIView)
Vue.prototype.$modal = VXETable.modal

Sortable.mount(new VxeGridTableEnhancement())

export default {
  data () {
    return {
      sortable2: null,
      showHelpTip2: false,
      loading: true,
      tableTreeData: [],
      tableColumnInit: [
        {
          width: 43,
          slots: {
            default: () => {
              return [
                <span class="drag-btn">
                  <Icon type="ios-menu" size="23" />
                </span>
              ]
            }
          }
        },
        {
          type: 'checkbox',
          width: 35
        },
        {
          title: this.$t(`bom_tool.edit.map_col.row_index`) + '#',
          field: `col_row_index`,
          treeNode: true,
          width: 120,
          slots: {
            default: 'error'
          }
        },
        {
          type: 'expand',
          width: 33,
          slots: {
            content: 'expand'
          }
        }
      ],
      tableColumnExpandInit: [
        {
          title: '',
          width: 43
        },
        {
          title: '',
          width: 35
        },
        {
          title: this.$t(`bom_tool.edit.map_col.row_index`) + '#',
          field: `col_row_index`,
          align: 'right',
          width: 120
        },
        {
          title: '',
          width: 33
        }
      ],
      tableColumn: [],
      tableColumnExpand: [],
      error_list: [],
      history_list: [],
      history_cursor: -1,
      history_current: null,
      history_going: false,
      prev: null,
      headerMap: [],
      headerOrder: [
        {
          key: 'type',
          width: 120,
          editRender: null
        },
        {
          key: 'line_quantity',
          width: 75,
          editRender: null
        },
        {
          key: 'chinese_name',
          width: 140,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        },
        {
          key: 'name',
          width: 150,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        },
        {
          key: 'mpn',
          width: 160,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        },
        {
          key: 'specification',
          width: 260,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        },
        {
          key: 'brand',
          width: 170,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        },
        {
          key: 'designator',
          width: 200,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        },
        {
          key: 'preferred_status',
          width: 100,
          editRender: null
        },
        {
          key: 'case_package',
          width: 100,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        },
        {
          key: 'unit_name',
          width: 60,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        },
        {
          key: 'part_number',
          width: 100,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        },
        {
          key: 'notes',
          width: 200,
          editRender: {
            name: 'Input',
            autoselect: true,
            props: {
              size: 'small'
            }
          }
        }
      ]
    }
  },
  props: {
    rows: {
      type: Array,
      required: true
    },
    columns: {
      type: Object,
      required: true
    },
    errors: {
      type: Array,
      required: true
    },
    editedRows: Object
  },
  mounted () {
    this.handleHeaderChange()
    this.handleRowChange()
    this.error_list = this.errors
  },
  watch: {
    rows: {
      handler (val, oldVal) {
        // Avoid execute twice although the values of rows are actually the same.
        if (!_.isEqual(val, oldVal)) {
          this.handleRowChange()
        }
      },
      deep: true
    },
    columns: {
      handler () {
        this.handleHeaderChange()
      },
      deep: true
    },
    errors: {
      handler () {
        this.error_list = this.errors
      },
      deep: true
    },
    tableTreeData: {
      handler () {
        if (this.tableTreeData !== null && this.prev !== null && this.tableTreeData.length > 0 && this.prev.length > 0 && !_.isEqual(this.tableTreeData, this.prev)) {
          this.$emit('on-change', this.tableTreeData)
          if (!this.history_going) {
            if (this.history_cursor !== -1) {
              this.history_list = this.history_list.slice(0, this.history_cursor + 1)
              this.history_cursor = -1
            }
            this.history_list.push(_.cloneDeep(this.prev))
            this.history_current = _.cloneDeep(this.tableTreeData)
            // this.$refs.xTable.syncData()
          } else {
            this.history_going = false
          }
        }
        this.$nextTick(() => {
          this.prev = _.cloneDeep(this.tableTreeData)
        })
      },
      deep: true
    }
  },
  beforeDestroy () {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    history_go (undo) {
      let maxIndex = this.history_list.length - 1
      if (undo) {
        if (this.history_cursor === -1) {
          this.history_cursor = maxIndex
        } else if (this.history_cursor > 0) {
          this.history_cursor--
        }
      } else {
        if (this.history_cursor >= 0 && this.history_cursor < maxIndex) {
          this.history_cursor++
        } else if (this.history_cursor === maxIndex) {
          this.history_cursor = -1
        }
      }
      this.history_going = true
      if (this.history_cursor !== -1) {
        this.tableTreeData = _.cloneDeep(this.history_list[this.history_cursor])
      } else {
        this.tableTreeData = _.cloneDeep(this.history_current || this.history_list[this.history_list.length - 1])
      }
      // this.$refs.xTable.syncData()
    },
    addExpandClass ({ row, rowIndex, column, columnIndex }) {
      if (this.isChanged(row, column, columnIndex)) {
        return 'expand-cell col--dirty'
      }
      return 'expand-cell'
    },
    handleHeaderChange () {
      this.tableColumn = _.cloneDeep(this.tableColumnInit)
      this.tableColumnExpand = _.cloneDeep(this.tableColumnExpandInit)
      this.headerMap = {}
      for (let col of this.headerOrder) {
        if (this.columns[col.key] !== null && typeof this.columns[col.key] !== 'undefined' && this.columns[col.key] !== '') {
          this.headerMap[`col_${this.columns[col.key]}`] = col.key
          if (col.key === 'preferred_status') {
            this.tableColumn.push({
              title: this.$t(`bom_tool.edit.map_col.${col.key}`),
              field: `col_${this.columns[col.key]}`,
              width: col.width
            })
            this.tableColumnExpand.push({
              title: this.$t(`bom_tool.edit.map_col.${col.key}`),
              field: `col_${this.columns[col.key]}`,
              width: col.width,
              editRender: {
                name: 'Select',
                props: {
                  size: 'small',
                  transfer: true
                },
                options: [
                  {
                    label: 'Preferred',
                    value: 'preferred'
                  },
                  {
                    label: 'Alternate',
                    value: 'alternate'
                  }
                ]
              }
            })
          } else if (col.key === 'line_quantity') {
            this.tableColumn.push({
              title: this.$t(`bom_tool.edit.map_col.${col.key}`),
              field: `col_${this.columns[col.key]}`,
              width: col.width,
              editRender: {
                name: 'Input',
                autoselect: true,
                props: {
                  size: 'small'
                }
              }
            })
            this.tableColumnExpand.push({
              title: this.$t(`bom_tool.edit.map_col.${col.key}`),
              field: `col_${this.columns[col.key]}`,
              width: col.width
            })
          } else if (col.key === 'type') {
            this.tableColumn.push({
              title: this.$t(`bom_tool.edit.map_col.${col.key}`),
              field: `col_${this.columns[col.key]}`,
              width: col.width,
              editRender: {
                name: 'Select',
                props: {
                  size: 'small',
                  transfer: true
                },
                options: [
                  {
                    label: 'Document',
                    value: 'Document'
                  },
                  {
                    label: 'Document Group',
                    value: 'Document Group'
                  },
                  {
                    label: 'Assembly',
                    value: 'Assembly'
                  },
                  {
                    label: 'Part',
                    value: 'Part'
                  }
                ]
              }
            })
            this.tableColumnExpand.push({
              title: this.$t(`bom_tool.edit.map_col.${col.key}`),
              field: `col_${this.columns[col.key]}`,
              width: col.width
            })
          } else {
            let item = {
              title: this.$t(`bom_tool.edit.map_col.${col.key}`),
              field: `col_${this.columns[col.key]}`,
              width: (col.key === 'specification' || col.key === 'notes') ? null : col.width,
              minWidth: (col.key === 'specification' || col.key === 'notes') ? col.width : null,
              showOverflow: 'tooltip',
              editRender: col.editRender
            }
            this.tableColumn.push(item)
            this.tableColumnExpand.push(item)
          }
        }
      }
    },
    handleRowChange () {
      this.tableTreeData = rebuildRows(this.rows)
      if (this.tableTreeData.length > 0) {
        this.loading = false
        // Has to clear the sortable object to avoid creating multiple times
        // which can cause messed up of duplicated items
        if (this.sortable2 !== null) {
          this.sortable2.destroy()
        }
        this.treeDrop()
        this.$nextTick(() => {
          this.$refs.xTable.setAllTreeExpand(true)
        })
      }

      function rebuildRows (rows) {
        let temp_rows = []
        for (let row of rows) {
          let temp_row = {
            children: [],
            col_row_index: row.row_number,
            id: row.id,
            row_type: row.row_type,
            alternatives: [],
            raw_data: {}
          }

          if (row.children?.length > 0) {
            temp_row.children = rebuildRows(row.children)
          }
          if (row.alternatives?.length > 0) {
            for (let alt_item of row.alternatives) {
              let alt = {
                children: [],
                col_row_index: alt_item.row_number,
                id: alt_item.id,
                parent_id: alt_item.parent_id,
                row_type: 'alternative'
              }
              alt.raw_data = {}
              for (let [index, value] of alt_item.row_data.entries()) {
                alt[`col_${index}`] = value
                alt.raw_data[`col_${index}`] = value
              }
              temp_row.alternatives.push(alt)
            }
          }
          // Loop the properties over data entry to change the key of each value
          for (let [index, value] of row.row_data.entries()) {
            temp_row[`col_${index}`] = value
            temp_row.raw_data[`col_${index}`] = value
          }
          temp_rows.push(temp_row)
        }
        return temp_rows
      }
    },
    rowClassName ({ row, rowIndex }) {
      for (let error of this.error_list) {
        if (error.row === row.col_row_index) {
          return 'error-row'
        }
      }
      return ''
    },
    ifExpand ({ column, columnIndex, $columnIndex, row, rowIndex, $rowIndex }) {
      if (row.alternatives.length > 0) {
        return true
      }
      return false
    },
    isError (row_index) {
      for (let error of this.error_list) {
        if (error.row === row_index) {
          return true
        }
      }
      return false
    },
    getErrorMessage (row_index) {
      for (let error of this.error_list) {
        if (error.row === row_index) {
          return error.message
        }
      }
      return ''
    },
    treeDrop () {
      this.$nextTick(() => {
        let xTable = this.$refs.xTable
        this.sortable2 = Sortable.create(document.querySelector('.bom-hierarchy-table .vxe-table--body tbody'), {
          handle: '.drag-btn',
          animation: 150,
          ghostClass: 'dragging',
          chosenClass: 'selected',
          swapThreshold: 0.05,
          vxeGridTableEnhancement: true,
          xTable: xTable,
          xTableTreeData: this.tableTreeData,
          xEUtils: XEUtils,
          xTableTreeDataChildrenProp: 'children'
        })
      })
    },
    cellClass ({ row, rowIndex, column, columnIndex }) {
      if (this.isChanged(row, column, columnIndex)) {
        return 'col--dirty'
      }
      return ''
    },
    finishEdit ({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) {
      if (this.isChanged(row, column, columnIndex)) {
        let foundFlag = false
        for (let i = 0; i < this.editedRows.normal.length; i++) {
          if (this.editedRows.normal[i].id === row.id) {
            foundFlag = true
            break
          }
        }
        if (!foundFlag) {
          let rowData = {
            type: row.row_type,
            id: row.id
          }
          for (let index of Object.keys(row)) {
            if (index.match(/col_\d{1,2}/g) !== null) {
              if (typeof this.headerMap[index] !== 'undefined') {
                rowData[this.headerMap[index]] = row[index]
              }
            }
          }
          this.editedRows.normal.push(rowData)
        }
      } else {
        for (let i = 0; i < this.editedRows.normal.length; i++) {
          if (this.editedRows.normal[i].id === row.id) {
            this.editedRows.normal.splice(i, 1)
            break
          }
        }
      }
    },
    finishExpandEdit ({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) {
      if (this.isChanged(row, column, columnIndex)) {
        let foundFlag = false
        for (let i = 0; i < this.editedRows.expand.length; i++) {
          if (this.editedRows.expand[i].id === row.id) {
            foundFlag = true
            break
          }
        }
        if (!foundFlag) {
          let rowData = {
            id: row.id
          }
          for (let index of Object.keys(row)) {
            if (index.match(/col_\d{1,2}/g) !== null) {
              if (typeof this.headerMap[index] !== 'undefined') {
                rowData[this.headerMap[index]] = row[index]
              }
            }
          }
          this.editedRows.expand.push(rowData)
        }
      } else {
        for (let i = 0; i < this.editedRows.expand.length; i++) {
          if (this.editedRows.expand[i].id === row.id) {
            this.editedRows.expand.splice(i, 1)
            break
          }
        }
      }
    },
    isChanged (row, column, columnIndex) {
      return row[column.property] !== row.raw_data[column.property] && columnIndex > 3 && !((typeof row[column.property] === 'undefined' || row[column.property] === null || row[column.property] === '') && (typeof row.raw_data[column.property] === 'undefined' || row.raw_data[column.property] === null || row.raw_data[column.property] === ''))
    }
  }
}
</script>

<style lang="less">
.bom-hierarchy-table {
  position: relative;
  width: 100%;
  height: ~"calc(100vh - 307.2px)";
  background-color: white;
  overflow: auto;
  &.loading {
    overflow: hidden;
  }
  .ivu-select-selected-value, .ivu-input.ivu-input-small {
    font-size: 12px!important;
  }
  .dragging, .dragging * {
    color: #E0EEFD;
  }
  .selected {
    background-color: fade(#2d8cf0, 15%);
    color: #2d8cf0;
  }
  .vxe-table .vxe-tree-cell {
    padding-left: 1.2em;
  }
  .row-error-tooltip {
    margin-left: 5px;
  }
  .vxe-tree--btn-wrapper {
    background-color: transparent;
  }
  .vxe-table .vxe-body--expanded-column {
    border-bottom: none;
  }
  .vxe-body--expanded-cell {
    padding: 0!important;
    padding-left: 0!important;
    .expand-cell {
      background-color: rgb(250, 250, 250);
      color: rgba(0, 0, 0, .6);
    }
    .vxe-table--body-wrapper {
      overflow: hidden;
    }
    .vxe-table--border-line {
      border-top: none;
      border-bottom: none;
    }
  }
}
.actions {
  width: 100%;
  margin: 0;
  margin-top: 18px;
  padding: 10px;
  background-color: #F8F8F9;
  border: 1px solid #E8EAEC;
  border-bottom: none;
  .history {
    margin: 0;
    padding: 0 10px;
  }
  .move {
    float: right;
    margin: 0!important;
  }
  .clear {
    clear: both;
  }
}
.target-row {
  margin-bottom: 15px;
}
.error-row {
  color: #ed4014;
  td {
    background-color: #FDECE7!important;
  }
}
.drag-btn {
  cursor: move;
}
</style>
